import React from 'react';
import { connect, useSelector } from 'react-redux';
import LoginContent from '../components/pages/user/login/content';
import WASelfProvisionNewUser from './WASelfProvisionNewUser';

function LoginPage(props) {
  const selfProvisionCreateForm = useSelector((state) => state.waitingAreaReducer.selfProvisionCreateForm);

  if (
    selfProvisionCreateForm &&
    selfProvisionCreateForm.isLinkValid &&
    (selfProvisionCreateForm.personStatus.toLowerCase() == 'e' ||
      (selfProvisionCreateForm.email != '' && selfProvisionCreateForm.personId == 0))
  ) {
    return <WASelfProvisionNewUser />;
  } else {
    return <LoginContent />;
  }
}

export default LoginPage;
